export class QueryWrapper {

    searchCriteriaMap: any;
    searchCriteriaComplexMap: any;
    regionRoutePrefixMap: any;     
    delayedScenarioCalendarMap: any;
    owkMasterTimelinesMap: any;
    delayedScenarioRouteMap: any;
    alloPropertiesMap: any;
    alloAprRateMaster: any;

    constructor() {
        this.searchCriteriaMap = {};
        this.searchCriteriaComplexMap = {}; 
        this.regionRoutePrefixMap = {};  
        this.delayedScenarioCalendarMap = {};            
        this.owkMasterTimelinesMap = {};
        this.delayedScenarioRouteMap = {};
        this.alloPropertiesMap = {};
        this.alloAprRateMaster = {};
    }
}